<template>
  <TabPanel value="insights">
    <FeatureCard
      span="2"
      title="Insights into your profile visitors"
      bg-color="secondary"
      color="secondary"
    >
      <VText gutter-bottom>
        Our analytics provide detailed insights into your profile visitors and
        link clicks.
      </VText>

      <FeatureCardList component="ol">
        <li>Lifetime views &amp; clicks</li>
        <li>Profile analytics</li>
        <li>Link analytics <Badge content="Pro" /></li>
        <li>Weekly insights email <Badge content="Pro" /></li>
        <li>Powerful reporting tools <Badge content="Pro+" /></li>
        <li>Filtering tools <Badge content="Pro+" /></li>
      </FeatureCardList>

      <video
        slot="img"
        src="~/assets/videos/home/analytics.mp4"
        loading="lazy"
        type="video/mp4"
        muted
        loop
        playsinline
        style="aspect-ratio: 16 / 9"
      />
    </FeatureCard>
  </TabPanel>
</template>

<script>
import { VText, TabPanel, Badge } from '@campsite-bio/component-lib';

import FeatureCard from '@/components/features/feature-card';
import FeatureCardList from '@/components/features/feature-card-list';

export default {
  components: {
    VText,
    TabPanel,
    Badge,
    FeatureCard,
    FeatureCardList,
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
